module.exports = {
      id: "shortform-usage",
      viewBox: "0 0 13.07 13.758",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#shortform",
      toString: function () {
        return this.url;
      }
    }